import * as stylex from "@stylexjs/stylex";
import {
  SPINNER_CENTER_COORDINATE,
  SPINNER_LINE_ANIMATION_STAGGER_MS,
  SPINNER_LINE_COUNT,
  SPINNER_LINE_END_COORDINATE,
  SPINNER_LINE_ROTATION_STEP_DEG,
  SPINNER_LINE_START_COORDINATE,
  SPINNER_VIEW_BOX,
} from "@/constants";

const spinnerLineFade = stylex.keyframes({
  "0%, 100%": { opacity: 0.2 },
  "12.5%": { opacity: 1 },
});

const styles = stylex.create({
  spinner: {
    width: "1rem",
    height: "1rem",
    flexShrink: 0,
  },
  line: {
    animationName: {
      default: spinnerLineFade,
      "@media (prefers-reduced-motion: reduce)": "none",
    },
    animationDuration: "1s",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
    stroke: "currentColor",
    opacity: { "@media (prefers-reduced-motion: reduce)": 0.7 },
  },
  lineDelay: (animationDelayMs: number) => ({
    animationDelay: `${animationDelayMs}ms`,
  }),
});

const Spinner = ({ styles: styleOverrides, ...props }: SpinnerProps) => (
  <svg
    aria-hidden="true"
    data-slot="spinner"
    fill="none"
    viewBox={SPINNER_VIEW_BOX}
    {...props}
    {...stylex.props(styles.spinner, styleOverrides)}
  >
    {Array.from({ length: SPINNER_LINE_COUNT }, (_, lineIndex) => (
      <line
        key={lineIndex}
        strokeLinecap="round"
        strokeWidth="2"
        transform={`rotate(${lineIndex * SPINNER_LINE_ROTATION_STEP_DEG} ${SPINNER_CENTER_COORDINATE} ${SPINNER_CENTER_COORDINATE})`}
        x1={SPINNER_CENTER_COORDINATE}
        x2={SPINNER_CENTER_COORDINATE}
        y1={SPINNER_LINE_START_COORDINATE}
        y2={SPINNER_LINE_END_COORDINATE}
        {...stylex.props(
          styles.line,
          styles.lineDelay(-lineIndex * SPINNER_LINE_ANIMATION_STAGGER_MS),
        )}
      />
    ))}
  </svg>
);

Spinner.displayName = "Spinner";

export { Spinner };
